import { purchaseOrdersTypes } from './actionTypes';

export const getPurchaseOrdersList = (payload: any) => ({
  type: purchaseOrdersTypes.GET_PURCHASE_ORDERS_DEFINITIONS,
  payload,
});

export const getPurchaseOrdersListSuccess = (payload: any) => ({
  type: purchaseOrdersTypes.GET_PURCHASE_ORDERS_SUCCESS,
  payload,
});

export const getPurchaseOrdersListFail = (error: any) => ({
  type: purchaseOrdersTypes.GET_PURCHASE_ORDERS_FAIL,
  payload: error,
});


export const getMilestoneConfigPO = (payload?: any)=>{
  return{
    type: purchaseOrdersTypes.GET_MILESTONESCONFIG_PO,
    payload,
  }
}

export const getMilestoneConfigPOSuccess = (payload:any)=>{
  return{
    type: purchaseOrdersTypes.GET_MILESTONESCONFIG_PO_SUCCESSS,
    payload,
  }
}

export const getMilestoneConfigPOFail = (payload:any)=>{
  return{
    type: purchaseOrdersTypes.GET_MILESTONESCONFIG_PO_FAIL,
    payload,
  }
}
